import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { JsonLoaderService } from '../../core/services/json-loader.service';
import { BehaviorSubject, first } from 'rxjs';
import { FormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { ScrollStrategyOptions } from '@angular/cdk/overlay';

@Component({
    selector: 'lgv-loan-app-terms-and-conditions-page',
    templateUrl: './loan-app-terms-and-conditions-page.component.html',
    styleUrls: ['./loan-app-terms-and-conditions-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoanAppTermsAndConditionsPageComponent implements OnInit {
    loanAppTerms$ = new BehaviorSubject(null);
    termsForm: UntypedFormGroup;

    constructor(private jsonLoader: JsonLoaderService,
        private fb: FormBuilder,
        private dialog: MatDialog,) {
        }

    ngOnInit(): void {
        this.loanAppTerms$ = this.jsonLoader.loanAppTermsAndConditionsJson$;
        this.termsForm = this.fb.group({});
        this.loanAppTerms$.pipe(first()).subscribe(terms => {
            terms.forEach(term => {
                this.termsForm.addControl(term.key, new FormControl(false, Validators.requiredTrue))
            });
        })
    }

    openViewTermsModal(index) {
        const term = this.loanAppTerms$.value[index];
        const viewTermsModal = this.dialog.open(ConfirmationDialogComponent, 
            {
                data: {
                    Confirmation: `<h1>${term?.terms?.title}</h1>${term?.terms?.detail}`,
                    woCancelButton: true
                }
            }
        )
    }

    navigateToStartLoanApp() {
        
    }

}
